module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-full-height"
  }, [(_vm.checkHeader) ? _c('header-section', {
    attrs: {
      "title": "Mini Calculators",
      "set-position": "relative",
      "set-width": "100"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-animated-calc u-no-padding u-no-margin u-d-block",
    class: {
      'p-animated-calc--no-header': !_vm.checkHeader
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "u-full-height",
    class: {
      'p-animated-calc__logo--default': _vm.isRouteByName('mini-calculators')
    }
  }, [_c('router-view'), _vm._v(" "), _c('mini-calc-icons'), _vm._v(" "), (_vm.isRouteByName('mini-calculators')) ? _c('div', {
    staticClass: "flex-grid flex-grid--row flex-grid--reduced-bottom-margin flex-grid--wrap p-animated-calc__icon-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "age_calculator",
      "tooltip-text": "An age calculator to help you determine how old someone would be at a certain date and how old they would be today.",
      "side": "top",
      "container-width": "200",
      "text-width": "250"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/age-calculator'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Age Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#age-calculator"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "care_calculator",
      "tooltip-text": "A calculator for determining the total cost of care provided between two periods. Allows for: basic or aggregate rate; gratuitous care discount; and a configurable hours of care per day.",
      "side": "top",
      "container-width": "200",
      "text-width": "220"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/care-calculator'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Care Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#care-calculator"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "dependency_multiplicand",
      "tooltip-text": "The dependency multiplicand calculator helps determine the dependency multiplicand using a deceased and dependant(s) incomes. Uses the recommended multiplier, based on the number of dependants, but also includes the option to set your own.",
      "side": "top",
      "container-width": "200",
      "text-width": "280"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/dependency-multiplicand'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Dependency Multiplicand")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#dependency-multiplicand"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "net_gross_earnings",
      "tooltip-text": "Our Net/Gross Earnings calculator enables you to determine total Net and Gross earnings for a person, during a period, from both employment income and/or pension income.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/gross-net-earnings'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Net/Gross Earnings")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#earnings"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "net_gross_pension",
      "tooltip-text": "The Net/Gross Pension calculator is a simplified version of our Net/Gross earnings calculator, designed for calculating the pension income of retired individuals.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/gross-net-pension'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Net/Gross Pension")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#pension"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "inflation_calculator",
      "tooltip-text": "An Inflation calculator which allows you to determine the change and see a comparison in the cost of goods and services between two dates.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/inflation-calculator'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Inflation Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#inflation-calculator"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "interest",
      "tooltip-text": "The Interest calculator enables you to calculate interest accrued on principal between two dates, using either simple or compound interest calculations, with a configurable interest rate and compound frequency.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/interest'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Interest")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#interest"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "interpolated_multipliers",
      "tooltip-text": "Our Interpolated Multipliers calculator allows you to determine multipliers from Ogden Discount Tables 1–26 and 28 with a configurable discount rate.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/interpolated-multipliers'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Interpolated Multipliers")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#interpolated"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "life_expectancy",
      "tooltip-text": "The Life Expectancy calculator enables you to determine the life expectancy of a person using any of the six provided methods: Ogden Table 1/2, Years/Months, Date of Death, Age at Death, % of normal life expectancy, and % reduction in normal life expectancy.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/life-expectancy'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Life Expectancy")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#life-expectancy"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "loss_of_earnings",
      "tooltip-text": "The Loss of Earnings calculator enables you to determine total Net Loss of earnings for a person over multiple periods",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/loss-of-earnings'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Loss of Earnings")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#loss-of-earnings"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "loss_of_pension",
      "tooltip-text": "The Loss of Pension calculator",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/loss-of-pension'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Loss of Pension")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#loss-of-pension"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "mesothelioma_psla_calculator",
      "tooltip-text": "The Calculator shows estimated common law awards according to 'age' and 'duration of symptoms'- the period between onset of the disease and death (or anticipated date of death).",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/mesothelioma-psla-calculator'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Mesothelioma PSLA Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#mesothelioma-psla-calculator"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "period_between_dates",
      "tooltip-text": "The Period Between Dates calculator can provide you with the number of years, months, weeks and/or days which have elapsed between two dates, with a configurable level of precision.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/period-between-two-dates'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Period Between Dates")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#period-dates"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "pre_post_assessment_discount",
      "tooltip-text": "The Pre & Post Assessment Discount calculator helps determine the assessment discounts applicable based on the age of the deceased and the duration of time between the deceased's date of death and the date of trial/cessation of dependency.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/pre-and-post-assessment-discounts'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Pre & Post Assessment Discount")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#table-e-f-discounts"
    }
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc__icon m-tooltip m-tooltip--above-high"
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": "retirement_age_calculator",
      "tooltip-text": "The Retirement Age Calculator provides the state retirement age for a person based on their date of birth and their gender.",
      "side": "top",
      "container-width": "200",
      "text-width": "240"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/mini-calculators/retirement-age'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openSubMenu()
      }
    }
  }, [_c('p', [_vm._v("Retirement Age Calculator")]), _vm._v(" "), _c('svg', {
    staticClass: "m-mini-calc-icon",
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#retirement-calculator"
    }
  })])])], 1)], 1)]) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-animated-calc__icon-container-description"
  }, [_c('h2', [_vm._v("\n                    Welcome to the mini calculators\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    These mini calculators allow you to perform discrete quantum calculations without the need to enter full claims details.\n                    "), _c('br'), _c('br'), _vm._v("\n                    You can download the results by pressing the print button.\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fd28818!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/MiniCalculators.vue
// module id = 1600
// module chunks = 0